import React, { ChangeEvent, DragEvent, forwardRef } from 'react';
import styled from 'styled-components';
import FileCodeIcon from './FileCodeIcon';
import FileInputButton from './FileInputButton';
import UploadIcon from './UploadIcon';
import { Text } from '../../../components/ui/text/Text';

const Container = styled.div`
  outline: 1px dashed #918d8d;
  padding: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DragDropText = styled.div`
  margin: 10px 0 0 0;
`;

const ButtonWrapper = styled.div`
  margin-top: 8px;
`;

interface FileUploaderProps {
  file: File | null;
  onDrop: (e: DragEvent<HTMLDivElement>) => void;
  onDragOver: (e: DragEvent<HTMLDivElement>) => void;
  onDragEnter: (e: DragEvent<HTMLDivElement>) => void;
  onDragLeave: (e: DragEvent<HTMLDivElement>) => void;
  onFileSelected: (event: ChangeEvent<HTMLInputElement>) => void;
}

const FileUploader = forwardRef<HTMLInputElement, FileUploaderProps>(
  (
    { file, onDrop, onDragOver, onDragEnter, onDragLeave, onFileSelected },
    ref
  ) => (
    <Container
      onDrop={onDrop}
      onDragOver={onDragOver}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
    >
      {!file && <UploadIcon />}
      {file && (
        <>
          <FileCodeIcon />
          <Text size="--font-size-600" color="--color-soft-gray">
            {file.name}
          </Text>
        </>
      )}
      <DragDropText>
        <Text size="--font-size-800" color="--color-soft-gray">
          Drag and Drop a PDF file
        </Text>
      </DragDropText>
      <Text size="--font-size-600" color="--color-soft-gray">
        or
      </Text>
      <ButtonWrapper>
        <FileInputButton ref={ref} onChange={onFileSelected} />
      </ButtonWrapper>
    </Container>
  )
);

export default React.memo(FileUploader);
